import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const Returns: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Returns & Exchanges Policy | Born in YU</title>
        <meta name="description" content="Read Born in YU's returns and exchanges policy. Learn about our return window, process, and conditions for Yugoslav nostalgia apparel." />
        <link rel="canonical" href="https://borninyu.com/returns" />
      </Helmet>
      <main className="min-h-screen bg-white">
      <section className="p-6 md:p-24">
        <div className="max-w-4xl mx-auto">
          <div className="border-[3px] border-black p-8 md:p-16 relative">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white px-4 border-[3px] border-black font-black uppercase tracking-widest text-sm">
              {t('returns.classification')}
            </div>

            <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-8">
              {t('footer.links.returns')}
            </h1>

            <div className="font-typewriter text-sm leading-relaxed uppercase text-gray-800 space-y-6">
              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('returns.returnWindow')}</h3>
                <p>{t('returns.returnWindowText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('returns.returnProcess')}</h3>
                <ol className="list-decimal list-inside space-y-2">
                  <li>{t('returns.returnStep1')}</li>
                  <li>{t('returns.returnStep2')}</li>
                  <li>{t('returns.returnStep3')}</li>
                  <li>{t('returns.returnStep4')}</li>
                  <li>{t('returns.returnStep5')}</li>
                </ol>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('returns.nonReturnable')}</h3>
                <ul className="list-disc list-inside space-y-2">
                  <li>{t('returns.nonReturnableItem1')}</li>
                  <li>{t('returns.nonReturnableItem2')}</li>
                  <li>{t('returns.nonReturnableItem3')}</li>
                </ul>
              </div>

              <div className="border-l-4 border-[#C41E3A] pl-6 py-4 bg-red-50">
                <h3 className="font-black text-lg mb-2 text-[#C41E3A]">{t('returns.exchanges')}</h3>
                <p>{t('returns.exchangesText')}</p>
              </div>

              <div className="border-2 border-black p-6 bg-gray-50 mt-8">
                <h3 className="font-black text-lg mb-4">{t('returns.damagedItems')}</h3>
                <p className="text-xs">{t('returns.damagedItemsText')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default Returns;
